<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Transaction</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link> /
      <router-link to="/transaction">Transactions</router-link> /
      <b>Summary</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <p>The page shows the summary of the transaction.</p>

        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">

            <h4 class="card-title mb-3">Summary</h4>

            <div class="row">
                <div class="col-md-6 form-group mb-3">
                    <label>Account Number</label>
                    <input class="form-control" v-model="transaction.balance[0].account_number" disabled />
                </div>

                <div class="col-md-6 form-group mb-3">
                    <label>Recipient Type</label>
                    <input class="form-control" v-model="transaction.recipient_type" disabled />
                </div>

                <div class="col-md-6 form-group mb-3">
                    <label>Transaction Type</label>
                    <input class="form-control" v-model="transaction.transaction_type" disabled />
                </div>
                
                <div class="col-md-6 form-group mb-3">
                    <label>Points Redeemed</label>
                    <input class="form-control" v-model="transaction.points" disabled />
                </div>

                <div class="col-md-6 form-group mb-3">
                    <label>Description</label>
                    <textarea class="form-control" v-model="transaction.description" disabled></textarea>
                </div>

                <div class="col-md-6 form-group mb-3">
                    <label>Date Redeemed</label>
                    <input class="form-control" v-model="transaction.created_at" disabled />
                </div>

                
            </div>

            <hr style="border:white">

            <router-link class="btn btn-primary" to="/transaction">
                Back
            </router-link>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style>
.active {
  background: none;
}
</style>


<script>
// @ is an alias to /src
import axios from "axios";
import moment from "moment";

export default {
  name: "vendor-transaction-summary",
  components: {
  },

  data() {
    return {
        transaction: []
    }
  },

  methods: {
      loadTransaction() {
      let token = localStorage.getItem("token");
      let id = this.$route.params.id

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/transaction/" + id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.transaction = res.data.transaction;

            // Recipient Type
            if(this.transaction.recipient_type == 1){
                this.transaction.recipient_type = "Vendor"
            } else if (this.transaction.recipient_type == 2){
                this.transaction.recipient_type = "Charity"
            } else{
                this.transaction.recipient_type = "User"
            }

            // Transaction Type
            if(this.transaction.transaction_type == 1){
                this.transaction.transaction_type = "Redeem"
            } else if (this.transaction.transaction_type == 2){
                this.transaction.transaction_type = "Transfer"
            } else if (this.transaction.transaction_type == 3){
                this.transaction.transaction_type = "Earn"
            } else{
                this.transaction.transaction_type = "Refund"
            }

            this.transaction.created_at = moment(new Date(this.transaction.created_at)).format("Do MMMM YYYY, h:mm a")

          })
      }
    },
  },

  mounted() {
      this.loadTransaction()
  }
};
</script>